import { trace } from 'rytm-helpers'


export const initHistoryLoadMore = () => {
  // Document CLICK
  document.addEventListener("click", onDocClick, false)
}

// ##########################
// ### Doc event handlers ###
// Doc click
const onDocClick = (e) => {
  if (e.target.dataset.loadUrl && e.target.dataset.wrapperSelector) {
    e.preventDefault()
    handleRequest(e.target)

  }
  
}

const handleRequest = (trigger) => {
  const url = trigger.dataset.loadUrl
  const wrapperSelector = trigger.dataset.wrapperSelector
  const wrapper = document.querySelector(wrapperSelector)
  if (!wrapper) {
    console.warn("wrapper was not found", wrapperSelector)
    return false
  }
  // ajax request
  let xhr = new XMLHttpRequest()
  // add event listeners
  // ## Load Success
  xhr.addEventListener('loadend', (e) => {
    trigger.parentNode.classList.add("disabled")
    wrapper.innerHTML += e.target.responseText
    onXhrLoadEnded()
  });
  // load start
  xhr.addEventListener('loadstart', () => {
    document.documentElement.classList.add("data-loading")
  });
  // xhr.addEventListener('load', onXhrLoad);
  // xhr.addEventListener('progress', onXhrProgress);
  xhr.addEventListener('error', onXhrLoadEnded);
  xhr.addEventListener('abort', onXhrLoadEnded);
  xhr.open('GET', url)
  xhr.send()
}

const onXhrLoadEnded = (e) => {
  document.documentElement.classList.remove("data-loading")
}
